import { useQuery } from '@tanstack/react-query';
import { KEYS } from '../../api/keys';
import { getSettings, setSettings } from '../../lib/settingsStore';
import { settingsApi } from './api';

/**
 * Loads the saved settings once and puts them where the screens read them, before the pages are drawn.
 * Returns true when the pages may be drawn.
 */
export function useLoadSettings(): boolean {
  const q = useQuery({ queryKey: KEYS.settings, queryFn: settingsApi.get, staleTime: Infinity });
  // only when they really differ, so saving from the Settings page does not set them twice
  if (q.data && JSON.stringify(q.data) !== JSON.stringify(getSettings())) setSettings(q.data);
  // if the server cannot be reached the pages are drawn with the defaults rather than not at all
  return q.isSuccess || q.isError;
}
